var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"am-down",class:{ 'has-text': _vm.text },on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('am-icon',{staticClass:"am-down__angle",attrs:{"name":"angle-down","size":"sm","dark":true}}),_c('am-text',{staticClass:"am-down__text",attrs:{"type":"caption"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }